import React, { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose, duration = 4000 }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className="fixed top-24 right-6 z-[100] max-w-sm animate-slide-up pointer-events-auto">
      <div 
        className={`p-4 rounded-xl shadow-2xl flex items-start space-x-3 border ${
          type === 'success' 
            ? 'bg-emerald-50 border-emerald-200 text-emerald-800' 
            : 'bg-rose-50 border-rose-200 text-rose-800'
        }`}
      >
        {/* Icon */}
        <div className="text-xl flex-shrink-0">
          {type === 'success' ? '✅' : '❌'}
        </div>
        
        {/* Content */}
        <div className="flex-1 text-sm font-medium">
          {message}
        </div>
        
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="text-slate-400 hover:text-slate-600 focus:outline-none text-xs px-1"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
